export const Constants = {
  api_url: process.env.VUE_APP_API_URL,
  graphql_url: process.env.VUE_APP_GRAPHQL_URL,
  cityManagerRoleId: '8b81214b-14b3-4a69-9ac3-57be81dcf255',
  adminRoleId: 'd279dbd5-a2bf-4046-941a-3ddee5d50e63',
  internalStatus: {
      pendingForApproval: '154dcbf5-2ee8-b60d-9f0d-3709944337bd',
      pendingForOrderConfirmation: '3f23bff3-97b9-4b5c-bda8-642ece31c698',
      orderNotReady: 'ffb4f463-33f1-4d05-9575-413f9f58cde7',
      underPickupProcess: '957e2962-ab02-4ceb-a57e-04bff9003682',
      readyForPickup: 'fc1a6143-389e-4474-8404-248b27af9867',                //Tempo is Ready to go
      approval: '98d24789-d38d-4426-b6bc-1be53a18fb80',
      tempoOnTheWayToPickupLoad: 'ccefb0de-fc2b-4a46-8e3f-996f04f40351',
      tempoWaitingForLoadingMaterial: '4b874954-4da5-4002-bbb7-52ba954c9b38',
      underBillingProcess: '00fb7496-c2f1-4361-b653-9507419d2096',
      onTheWayToPickupCityWarehouse: '0d61b7c8-c508-42b4-8da6-ef087e68ea05',
      underVerificationAtPickupCityWarehouse: '15fae42a-f0d7-4f84-a995-a2d833864cbe',
      inProcessOfDeparture: '60e848de-41bb-4da4-b201-596107f1904f',
      waitingForDeparture: 'b3dc515a-9757-4f04-90c9-72860f32b4b3',             //Ready For Deparature
      onTheWayToDropCityWarehouse: 'bcd55c8e-76f1-410b-ae50-51931ed987bf',
      atDestinationCityWarehouse: 'ea40091b-fb89-4774-ab6d-ec34e638957e',
      readyForFinalDelivery: 'c21a4e98-cc3a-41db-ae8c-f197c734dbd9',
      completed: 'ed2747e7-c86b-48c7-96db-b10c509c27cf',
      rejected: '912cba99-37cb-41fb-ae2e-2a472200af64',
      cancel: '24e00980-9a93-496c-b422-7b17a9ddfc2a'
  },
  ClientInvoiceStatus: {
    New: 'e9aa43b1-45a4-4d5d-9c0b-330eea7b0a7f',
    PendingForApproval: '56220462-346c-4e3f-938a-58e798805c0e',
    PendingForCancel: 'e3d1402b-2dd0-42b1-9d95-d850c783853e',
    Unpaid: '514e0e97-6c58-427b-b059-b9264a3d727e',
    Canceled: 'a572d961-3b84-471a-ae32-00f11d70b75b'
  },
  PointTypes:{
    OrderCity: '7e84e541-5502-4376-8347-4eb3932128ca',
    PickupCity: '2927ff66-14c5-4468-9bb8-2eb0e43bc2d1',
    DropCity: '2629a4f0-bace-49d7-b86a-9cde1bbc1955'
  },
  companyType:{
      dealer: '3a3248e1-f7a9-1982-1309-f9b6b780af40',
      manufacture: '17f23eaa-134d-72d4-219c-35b0da7832ae',
      wholesaler: '0842dd15-1070-60f2-dbf5-c42755494e3a',
      transporter: '2f71360b-aae2-4a5c-9c57-6b2a68c557a6',
  },
  materialSizes: ['small', 'medium', 'big'],               //Order
  cancellationReasonOptions:[
    'Material is not Ready',
    'Order didn’t confirm by pickup point',
    'Incorrect Information or data is missing',
    'Empty return due to delay at pickup point',
    'Same day pickup not possible',
    'Pickup not Possible',
    'Transport Vehicle was not available',
    'Local Pickup Vehicle was not available',
    'Rate is high for',
    'Misbehave by Client',
    'Misbehave by Tatkalorry staff',
    'Delay/improper response to client',
    'Duplicate Order',
    'Wrong material picked up',
    'Other',
  ],
  emailPattern: /^(([^<>()\\[\]\\.,;:\s@"]+(\.[^<>()\\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
}
export const PointNames = {
  [Constants.PointTypes.OrderCity]: 'Order City',
  [Constants.PointTypes.PickupCity]: 'Pickup City',
  [Constants.PointTypes.DropCity]: 'Drop City',
}
export const pickupProcessInternalStatuses = [Constants.internalStatus.pendingForApproval,Constants.internalStatus.pendingForOrderConfirmation,
  Constants.internalStatus.orderNotReady, Constants.internalStatus.underPickupProcess,Constants.internalStatus.readyForPickup,
  Constants.internalStatus.tempoOnTheWayToPickupLoad,Constants.internalStatus.tempoWaitingForLoadingMaterial,
  Constants.internalStatus.underBillingProcess,Constants.internalStatus.onTheWayToPickupCityWarehouse,
  Constants.internalStatus.underVerificationAtPickupCityWarehouse, Constants.internalStatus.inProcessOfDeparture,Constants.internalStatus.waitingForDeparture]
export const internalStatus = {
    pendingForApproval: JSON.stringify('154dcbf5-2ee8-b60d-9f0d-3709944337bd'),
    pendingForOrderConfirmation: JSON.stringify('3f23bff3-97b9-4b5c-bda8-642ece31c698'),
    orderNotReady: JSON.stringify('ffb4f463-33f1-4d05-9575-413f9f58cde7'),
    underPickupProcess: JSON.stringify('957e2962-ab02-4ceb-a57e-04bff9003682'),
    readyForPickup: JSON.stringify('fc1a6143-389e-4474-8404-248b27af9867'),           //Tempo is Ready to go
    approval: JSON.stringify('98d24789-d38d-4426-b6bc-1be53a18fb80'),
    tempoOnTheWayToPickupLoad: JSON.stringify('ccefb0de-fc2b-4a46-8e3f-996f04f40351'),
    tempoWaitingForLoadingMaterial: JSON.stringify('4b874954-4da5-4002-bbb7-52ba954c9b38'),
    underBillingProcess: JSON.stringify('00fb7496-c2f1-4361-b653-9507419d2096'),
    onTheWayToPickupCityWarehouse: JSON.stringify('0d61b7c8-c508-42b4-8da6-ef087e68ea05'),
    underVerificationAtPickupCityWarehouse: JSON.stringify('15fae42a-f0d7-4f84-a995-a2d833864cbe'),
    inProcessOfDeparture: JSON.stringify('60e848de-41bb-4da4-b201-596107f1904f'),
    waitingForDeparture: JSON.stringify('b3dc515a-9757-4f04-90c9-72860f32b4b3'),        //Ready For Deparature
    onTheWayToDropCityWarehouse: JSON.stringify('bcd55c8e-76f1-410b-ae50-51931ed987bf'),
    atDestinationCityWarehouse: JSON.stringify('ea40091b-fb89-4774-ab6d-ec34e638957e'),
    readyForFinalDelivery: JSON.stringify('c21a4e98-cc3a-41db-ae8c-f197c734dbd9'),
    completed: JSON.stringify('ed2747e7-c86b-48c7-96db-b10c509c27cf'),
    rejected: JSON.stringify('912cba99-37cb-41fb-ae2e-2a472200af64'),
    cancel: JSON.stringify('24e00980-9a93-496c-b422-7b17a9ddfc2a')
}

export const TempoTypes = [
  {label:'Auto', value:'auto'},
  {label:'Chota Hati', value:'chotaHati'},
  {label:'Chhakdo', value:'chhakdo'},
  {label:'Pick up', value:'pickup'},
  {label:'407', value:'407'},
]

export function convertArrToObj(array, key, value) {
    let obj = {};
    for(var i = 0; i < array.length; i++){
        obj[array[i][key]] = array[i][value]
    }
    return obj
}
export function generateUUID() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8)
        return v.toString(16)
    })
}
export function interpretErrorMessage(message) {
    let subMessage = message.slice(0, message.indexOf('.'))
    if(subMessage == 'Uniqueness violation'){
        return 'Same'
    }
}


export const TableSettings = {}

TableSettings[Constants.adminRoleId] = {
  [Constants.internalStatus.pendingForApproval]:{
    'orders_pickupDate':{ isReadOnly: false },
    'internalStatus':{ isReadOnly: false },
    'pickupAreaGroup':{ isReadOnly: false },
  },
  [Constants.internalStatus.pendingForOrderConfirmation]:{
    'internalStatus':{ isReadOnly: false },
    'orderDetails_lrName_lrObject':{ isReadOnly: false },
    'boxes':{ isReadOnly: false },
    'tempoPlateNum':{ isReadOnly: false },
    'truckPlateNumber':{ isReadOnly: false },
    'pickupAreaGroup':{ isReadOnly: false },
    'dropPartyName':{ isReadOnly: false },
  },
  [Constants.internalStatus.orderNotReady]:{
    'internalStatus':{ isReadOnly: false },
    'orderDetails_lrName_lrObject':{ isReadOnly: false },
    'boxes':{ isReadOnly: false },
    'tempoPlateNum':{ isReadOnly: false },
    'truckPlateNumber':{ isReadOnly: false },
    'pickupAreaGroup':{ isReadOnly: false },
    'dropPartyName':{ isReadOnly: false },
  },
  [Constants.internalStatus.underPickupProcess] : {
    'internalStatus':{ isReadOnly: false },
    'orderDetails_lrName_lrObject':{ isReadOnly: false },
    'boxes':{ isReadOnly: false },
    'tempoPlateNum':{ isReadOnly: false },
    'truckPlateNumber':{ isReadOnly: false },
    'pickupAreaGroup':{ isReadOnly: false },
    'dropPartyName':{ isReadOnly: false },
  },
  [Constants.internalStatus.readyForPickup] : {
    'internalStatus':{ isReadOnly: false },
    'orderDetails_lrName_lrObject':{ isReadOnly: false },
    'boxes':{ isReadOnly: false },
    'tempoPlateNum':{ isReadOnly: false },
    'truckPlateNumber':{ isReadOnly: false },
    'pickupAreaGroup':{ isReadOnly: false },
    'dropPartyName':{ isReadOnly: false },
  },
  [Constants.internalStatus.approval] : {
    'internalStatus':{ isReadOnly: false },
    'orderDetails_lrName_lrObject':{ isReadOnly: false },
    'boxes':{ isReadOnly: false },
    'tempoPlateNum':{ isReadOnly: false },
    'truckPlateNumber':{ isReadOnly: false },
    'pickupAreaGroup':{ isReadOnly: false },
    'dropPartyName':{ isReadOnly: false },
  },
  [Constants.internalStatus.tempoOnTheWayToPickupLoad] : {
    'internalStatus':{ isReadOnly: false },
    'orderDetails_lrName_lrObject':{ isReadOnly: false },
    'boxes':{ isReadOnly: false },
    'tempoPlateNum':{ isReadOnly: false },
    'truckPlateNumber':{ isReadOnly: false },
    'pickupAreaGroup':{ isReadOnly: false },
    'dropPartyName':{ isReadOnly: false },
  },
  [Constants.internalStatus.tempoWaitingForLoadingMaterial] : {
    'internalStatus':{ isReadOnly: false },
    'orderDetails_lrName_lrObject':{ isReadOnly: false },
    'boxes':{ isReadOnly: false },
    'tempoPlateNum':{ isReadOnly: false },
    'truckPlateNumber':{ isReadOnly: false },
    'pickupAreaGroup':{ isReadOnly: false },
    'dropPartyName':{ isReadOnly: false },
  },
  [Constants.internalStatus.underBillingProcess] : {
    'internalStatus':{ isReadOnly: false },
    'orderDetails_lrName_lrObject':{ isReadOnly: false },
    'boxes':{ isReadOnly: false },
    'tempoPlateNum':{ isReadOnly: false },
    'truckPlateNumber':{ isReadOnly: false },
    'dropPartyName':{ isReadOnly: false },
  },
  [Constants.internalStatus.onTheWayToPickupCityWarehouse] : {
    'internalStatus':{ isReadOnly: false },
    'orderDetails_lrName_lrObject':{ isReadOnly: false },
    'boxes':{ isReadOnly: false },
    'tempoPlateNum':{ isReadOnly: false },
    'truckPlateNumber':{ isReadOnly: false },
    'dropPartyName':{ isReadOnly: false },
  },
  [Constants.internalStatus.underVerificationAtPickupCityWarehouse] : {
    'internalStatus':{ isReadOnly: false },
    'orderDetails_lrName_lrObject':{ isReadOnly: false },
    'boxes':{ isReadOnly: false },
    'tempoPlateNum':{ isReadOnly: false },
    'truckPlateNumber':{ isReadOnly: false },
    'dropPartyName':{ isReadOnly: false },
  },
  [Constants.internalStatus.inProcessOfDeparture] : {
    'internalStatus':{ isReadOnly: false },
    'orderDetails_lrName_lrObject':{ isReadOnly: false },
    'orderDetails_ewayBillNo':{ isReadOnly: false },
    'boxes':{ isReadOnly: false },
    'truckPlateNumber':{ isReadOnly: false },
    'dropPartyName':{ isReadOnly: false },
  },
  [Constants.internalStatus.waitingForDeparture] : {
    'internalStatus':{ isReadOnly: false },
    'orderDetails_lrName_lrObject':{ isReadOnly: false },
    'truckPlateNumber':{ isReadOnly: false },
  },
  [Constants.internalStatus.onTheWayToDropCityWarehouse] : {
    'internalStatus':{ isReadOnly: false },
    'truckPlateNumber':{ isReadOnly: false },
  },
  [Constants.internalStatus.atDestinationCityWarehouse] : {
    'internalStatus':{ isReadOnly: false },
    'truckPlateNumber':{ isReadOnly: false },
  },
  [Constants.internalStatus.readyForFinalDelivery] : {
    'internalStatus':{ isReadOnly: false }
  }
}

TableSettings[Constants.cityManagerRoleId] = {
  [Constants.internalStatus.pendingForApproval]:{
    'orders_pickupDate':{ isReadOnly: false },
    'internalStatus':{ isReadOnly: false },
    'pickupAreaGroup':{ isReadOnly: false },
    'boxes':{ isReadOnly: false },
    'truckPlateNumber':{ isReadOnly: false },
  },
  [Constants.internalStatus.pendingForOrderConfirmation]:{
    'orders_pickupDate':{ isReadOnly: false },
    'internalStatus':{ isReadOnly: false },
    'orderDetails_lrName_lrObject':{ isReadOnly: false },
    'boxes':{ isReadOnly: false },
    'truckPlateNumber':{ isReadOnly: false },
    'orderDetails_ewayBillNo':{ isReadOnly: false },
    'tempoPlateNum':{ isReadOnly: false },
    'pickupAreaGroup':{ isReadOnly: false },
  },
  [Constants.internalStatus.orderNotReady]:{
    'orders_pickupDate':{ isReadOnly: false },
    'internalStatus':{ isReadOnly: false },
    'orderDetails_lrName_lrObject':{ isReadOnly: false },
    'boxes':{ isReadOnly: false },
    'truckPlateNumber':{ isReadOnly: false },
    'orderDetails_ewayBillNo':{ isReadOnly: false },
    'tempoPlateNum':{ isReadOnly: false },
    'pickupAreaGroup':{ isReadOnly: false },
  },
  [Constants.internalStatus.underPickupProcess] : {
    'orders_pickupDate':{ isReadOnly: false },
    'internalStatus':{ isReadOnly: false },
    'orderDetails_lrName_lrObject':{ isReadOnly: false },
    'boxes':{ isReadOnly: false },
    'truckPlateNumber':{ isReadOnly: false },
    'orderDetails_ewayBillNo':{ isReadOnly: false },
    'tempoPlateNum':{ isReadOnly: false },
    'pickupAreaGroup':{ isReadOnly: false },
  },
  [Constants.internalStatus.readyForPickup] : {
    'orders_pickupDate':{ isReadOnly: false },
    'internalStatus':{ isReadOnly: false },
    'orderDetails_lrName_lrObject':{ isReadOnly: false },
    'boxes':{ isReadOnly: false },
    'truckPlateNumber':{ isReadOnly: false },
    'orderDetails_ewayBillNo':{ isReadOnly: false },
    'tempoPlateNum':{ isReadOnly: false },
    'pickupAreaGroup':{ isReadOnly: false },
  },
  [Constants.internalStatus.approval] : {
    'orders_pickupDate':{ isReadOnly: false },
    'internalStatus':{ isReadOnly: false },
    'orderDetails_lrName_lrObject':{ isReadOnly: false },
    'boxes':{ isReadOnly: false },
    'truckPlateNumber':{ isReadOnly: false },
    'orderDetails_ewayBillNo':{ isReadOnly: false },
    'tempoPlateNum':{ isReadOnly: false },
    'pickupAreaGroup':{ isReadOnly: false },
  },
  [Constants.internalStatus.tempoOnTheWayToPickupLoad] : {
    'orders_pickupDate':{ isReadOnly: false },
    'internalStatus':{ isReadOnly: false },
    'orderDetails_lrName_lrObject':{ isReadOnly: false },
    'boxes':{ isReadOnly: false },
    'truckPlateNumber':{ isReadOnly: false },
    'orderDetails_ewayBillNo':{ isReadOnly: false },
    'tempoPlateNum':{ isReadOnly: false },
    'pickupAreaGroup':{ isReadOnly: false },
  },
  [Constants.internalStatus.tempoWaitingForLoadingMaterial] : {
    'orders_pickupDate':{ isReadOnly: false },
    'internalStatus':{ isReadOnly: false },
    'orderDetails_lrName_lrObject':{ isReadOnly: false },
    'boxes':{ isReadOnly: false },
    'truckPlateNumber':{ isReadOnly: false },
    'orderDetails_ewayBillNo':{ isReadOnly: false },
    'tempoPlateNum':{ isReadOnly: false },
    'pickupAreaGroup':{ isReadOnly: false },
  },
  [Constants.internalStatus.underBillingProcess] : {
    'orders_pickupDate':{ isReadOnly: false },
    'internalStatus':{ isReadOnly: false },
    'orderDetails_lrName_lrObject':{ isReadOnly: false },
    'boxes':{ isReadOnly: false },
    'truckPlateNumber':{ isReadOnly: false },
    'orderDetails_ewayBillNo':{ isReadOnly: false },
    'tempoPlateNum':{ isReadOnly: false },
    'pickupAreaGroup':{ isReadOnly: false },

  },
  [Constants.internalStatus.onTheWayToPickupCityWarehouse] : {
    'orders_pickupDate':{ isReadOnly: false },
    'internalStatus':{ isReadOnly: false },
    'orderDetails_lrName_lrObject':{ isReadOnly: false },
    'boxes':{ isReadOnly: false },
    'truckPlateNumber':{ isReadOnly: false },
    'orderDetails_ewayBillNo':{ isReadOnly: false },
    'tempoPlateNum':{ isReadOnly: false },
    'pickupAreaGroup':{ isReadOnly: false },

  },
  [Constants.internalStatus.underVerificationAtPickupCityWarehouse] : {
    'internalStatus':{ isReadOnly: false },
    'orderDetails_lrName_lrObject':{ isReadOnly: false },
    'boxes':{ isReadOnly: false },
    'truckPlateNumber':{ isReadOnly: false },
    'orderDetails_ewayBillNo':{ isReadOnly: false },

  },
  [Constants.internalStatus.inProcessOfDeparture] : {
    'internalStatus':{ isReadOnly: false },
    'orderDetails_lrName_lrObject':{ isReadOnly: false },
    'boxes':{ isReadOnly: false },
    'truckPlateNumber':{ isReadOnly: false },
    'orderDetails_ewayBillNo':{ isReadOnly: false },

  },
  [Constants.internalStatus.waitingForDeparture] : {                         //Ready To Depart
    'internalStatus':{ isReadOnly: false },
    'orderDetails_lrName_lrObject':{ isReadOnly: false },
    'boxes':{ isReadOnly: false },
    'truckPlateNumber':{ isReadOnly: false },
    'orderDetails_ewayBillNo':{ isReadOnly: false },
  },
  [Constants.internalStatus.onTheWayToDropCityWarehouse] : {
    'internalStatus':{ isReadOnly: false },
    'dropPartyName':{ isReadOnly: false },
  },
  [Constants.internalStatus.atDestinationCityWarehouse] : {
    'internalStatus':{ isReadOnly: false },
    'dropPartyName':{ isReadOnly: false },
  },
  [Constants.internalStatus.readyForFinalDelivery] : {
    'internalStatus':{ isReadOnly: false },
    'dropPartyName':{ isReadOnly: false },
  }
}

export const CommentSettings = {}
CommentSettings[Constants.internalStatus.pendingForApproval] = {
 'str': 'Order Should be ready',
 checkFields: [
     {
         field: 'orderDetails_lrName_lrObject',
         str: 'Enter LR Number',
     }
 ]
}
CommentSettings[Constants.internalStatus.approval] = {
 'str': 'Order Should be ready',
 checkFields: [
     {
         field: 'orderDetails_lrName_lrObject',
         str: 'Enter LR Number',
     }
 ]
}


// let roleId = {                           //cityManager_salesExec
//     url_endpoint: {                      //excel-formatted-orders
//         "stageId-1": {                       //pendingForApproval
//             column1: {isReadOnly: false},
//             column2: {isReadOnly: false},
//
//             columnN: {isReadOnly: false},
//             executeFunction: 'function_name'
//         },
//         "stageId-2": {                       //NotReadyForConfirmation
//             column1: {isReadOnly: false},
//             column2: {isReadOnly: false},
//
//             columnN: {isReadOnly: false},
//             executeFunction: 'function_name'
//         }
//     }
// }
